import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { OrderStatus } from 'src/app/core/orders.service';
import { ListStepsParams } from 'src/app/core/steps.service';
import { UtilsService } from 'src/app/core/utils.service';
import {
  FORM_ORDER_ID_FIELD_LABEL,
  FORM_CREATED_FROM_FIELD_LABEL,
  FORM_CREATED_TO_FIELD_LABEL,
  FORM_DUE_DATE_FROM_FIELD_LABEL,
  FORM_DUE_DATE_TO_FIELD_LABEL,
  QINETIC_ID_LABEL,
  FORM_STEP_ID_FIELD_LABEL,
} from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-steps-filters',
  templateUrl: './steps-filters.component.html',
  styleUrls: ['./steps-filters.component.scss'],
})
export class StepsFiltersComponent {
  @Input() filters?: ListStepsParams;
  @Output() filter_clear: EventEmitter<ListStepsParams> = new EventEmitter<ListStepsParams>();

  constructor(private date_pipe: DatePipe, private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        return this.isKeySet(k);
      });
    }
    return [];
  }

  getOrderStatusLabel(status?: OrderStatus): string {
    if (!status) return '';
    return status?.replace(',running', '');
  }

  isKeySet(key: string): boolean {
    if (!this.filters) return false;
    return this.utils_service.isFilterKeySet(this.filters, key);
  }

  getLabelByKey(key: string): string {
    switch (key) {
      case 'order_id':
        return FORM_ORDER_ID_FIELD_LABEL;

      case 'qinetic_id':
        return QINETIC_ID_LABEL;

      case 'created_from':
        return FORM_CREATED_FROM_FIELD_LABEL;

      case 'created_to':
        return FORM_CREATED_TO_FIELD_LABEL;

      case 'due_date_from':
        return FORM_DUE_DATE_FROM_FIELD_LABEL;

      case 'due_date_to':
        return FORM_DUE_DATE_TO_FIELD_LABEL;

      case 'steps_id':
        return FORM_STEP_ID_FIELD_LABEL;

      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    switch (key) {
      case 'order_id':
        return this.filters?.order_id || '-';

      case 'qinetic_id':
        return this.filters?.qinetic_id || '-';

      case 'created_from':
        return this.toStringDate(this.filters?.created_from || 0);

      case 'created_to':
        return this.toStringDate(this.filters?.created_to || 0);

      case 'due_date_from':
        return this.toStringDate(this.filters?.due_date_from || 0);

      case 'due_date_to':
        return this.toStringDate(this.filters?.due_date_to || 0);

      case 'steps_id':
        return this.filters?.steps_id || '-';

      default:
        return '';
    }
  }

  toStringDate(date: number): string {
    return this.date_pipe.transform(date, 'shortDate') || '-';
  }
}
